import type { ComponentProps, ReactElement } from 'react';

import {
    BRANDS,
    CookieBanner,
    FullPageCookieBanner,
    cookieBannerPolicyLinks as plasticCookieBannerPolicyLinks
} from '@cof/plastic-components';
import { addSParameterToLinkUrl } from '../../utilities/utils';
import config from '@cof/ukweb-config/lib/clientConfig';
import { offers } from '../../api/client/adobe';
import { timeout } from '../../utilities/promises';

type TransformedCookieBannerProps = Omit<ComponentProps<typeof CookieBanner>, 'allowRejectAll' | 'policyLinks'>;

const TransformedCookieBanner = (props: TransformedCookieBannerProps): ReactElement => {
    const fullPageCookieBanner = config.get('features.fullPageCookieBanner');
    const policyLinks = Object.entries(plasticCookieBannerPolicyLinks).reduce((updatedPolicyLinks, [brand, link]) => {
        const query = new URLSearchParams(window.location.search);
        const sParameter = query.get('s') || undefined;
        const url = new URL(link);
        const urlWithsParam = addSParameterToLinkUrl({ url: url.href, sParameter });
        return {
            ...updatedPolicyLinks,
            [brand === BRANDS.CAPITAL_ONE ? 'capitalOne' : brand.toLowerCase()]: urlWithsParam
        };
    }, {});
    if (fullPageCookieBanner) {
        return (
            // @ts-expect-error TS2741 -- plastic's FullPageCookieBanner doesn't require isOpen
            <FullPageCookieBanner
                allowRejectAll
                policyLinks={policyLinks}
                {...props}
                dismissSync={() => Promise.any([timeout(4000), offers])}
            />
        );
    }
    return <CookieBanner allowRejectAll policyLinks={policyLinks} {...props} />;
};

export default TransformedCookieBanner;
